import React from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import MyButton from '../../../UI/form/MyButton'
import SuccessMessage from '../../../UI/messages/SuccessMessage'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { editUserSettingsAPI } from '../../../../api/user/userAPI'
import SupplierTypeSelect from '../../../supply/suppliers/form/fields/SupplierTypeSelect'
import UserSettingsScanTypeSelect from './fields/UserSettingsScanTypeSelect'

const UserSettingsForm = ({ settingsBd, setOpen }) => {

    const [data, setData] = useState(settingsBd ? settingsBd : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        // console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        edit(dataForBd)
    }

    const edit = (dataForBd) => {
        editUserSettingsAPI(dataForBd).then(data => {
            if (setOpen) {
                setOpen(false)
            }
            setSuccess('Дані успішно оновлено')
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            scanType: data.scanType,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple formW50'>
        {
			formDataProductIsField('scanType', 'userSettings') ?
				<UserSettingsScanTypeSelect
					required={formDataProductRequiredField('scanType', 'userSettings')}
					setValidate={e => updateValidate(setValid, 'scanType', e)}
					setValueForm={e => setValueForm(setData, 'scanType', e)}
					forciblyValue={data && data.scanType ? data.scanType : ''}
				/>
			: ''
        }

        <SuccessMessage
            success={success}
        />
        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default UserSettingsForm